export default __webpack_public_path__ + "static/BookIcon-24b1f8d7491eb5f09ae4c9a96fe73d65.png";